import { render, staticRenderFns } from "./Inscription-email.vue?vue&type=template&id=f72c92ea&scoped=true&"
import script from "./Inscription-email.vue?vue&type=script&lang=js&"
export * from "./Inscription-email.vue?vue&type=script&lang=js&"
import style0 from "./Inscription-email.vue?vue&type=style&index=0&id=f72c92ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72c92ea",
  null
  
)

export default component.exports